<template>
  <el-container class="login-container">
    <div class="QRcodeMain">
      <div class="bg"><img src="../../assets/1.png" alt="" class="img1"></div>
      <div id="weixin" class="QRcode"></div>
    </div>
    <div class="footer">苏ICP备2022006600号-1｜Copyright © 2019-2024 www.ladesports.com All Rights Reserved 行球足（苏州）科技有限公司版权所有  XML地图</div>
  </el-container>
  
</template>
<script type="text/javascript" src="http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script>
<script>
export default {
  data() {
    return {
      banner:[
        {
          image:"https://img1.baidu.com/it/u=3183565747,4085678136&fm=253&fmt=auto&app=138&f=JPEG?w=1000&h=500"
        },
        {
          image:"https://img0.baidu.com/it/u=3447847323,3579500877&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=310"
        }
      ],
      banner2:[
        {
          image:"https://img2.baidu.com/it/u=1664375150,2646904745&fm=253&fmt=auto&app=120&f=JPEG?w=465&h=300"
        },
        {
          image:"https://img0.baidu.com/it/u=3437919487,1968736136&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=502"
        }
      ]
    };
  },

  methods: {
    getCodeMes() {
      let code = this.getQueryString("code");
      console.log("地址中的code:", code);
      if (!code) {
        this.createWxQrcode();
      } else {
        this.getLoginMes(code);
      }
    },

    //使用正则读取url里的code
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      // console.log(window.location.search);
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return "";
    },

    async getLoginMes(code) {
      console.log('通过返回的code获取后台token:', code);
      const { res } = await this.$http.get(`/AdminUser/CheckLogin?code=${code}`);
      if (res.isSuccess) {
        localStorage.setItem('Authorization', res.data.token);
        localStorage.setItem('user_info', JSON.stringify(res.data.info));

        this.$http.get('/Field/GetFieldList').then(response => {
          if (response.res.isSuccess) {
            const fieldList = response.res.data || [];
            if (fieldList.length) {
              localStorage.setItem('fieldId', fieldList[0].fieldId);
              localStorage.setItem('currentField', JSON.stringify(fieldList[0]));
            }
            location.reload();
          }
        });
      }
    },

    createWxQrcode() {
      // 生成微信登录二维码
      var obj = new WxLogin({
        self_redirect: false,
        id: "weixin", // 页面显示二维码的容器id
        appid: "wxc7ca6974731e30ac", // 微信官方提供的测试id
        scope: "snsapi_login",
        //redirect_uri: encodeURI("http://qiuchangzhu.ladesports.com/logindev/login"), // 微信官方中的测试环境url地址
        redirect_uri: encodeURI("http://qiuchangzhu.ladesports.com/login"), // 微信官方中的正式环境url地址
        state: "bind",
        style: "black",
        href: "",
      });
    }
  },
  mounted() {
    // this.createWxQrcode();
    this.getCodeMes();
  }
};


</script>

<style lang="scss" scoped> 
.login-container {
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background: url(../../assets/loginbg.jpg) repeat left top;

.QRcodeMain {
  height: 500px;
  width: auto;
  display: flex;
}

.bg {
  width: 100%;
  height: 500px;
  float: left;
  }

.QRcode {
  width: 370px;
  height: 500px;
  padding: 20px;
  border-radius: 10px;
  background: white;
  float: right;
  }

  .img1{
    width: 100%;
    height: 500px;
    float: left;
    
  border-radius: 10px;
  }

  .footer{
    bottom: 0;
    left: 0;
    width: 100%;
    height: 39px;
    padding-top: 1px;
    zoom: 1;
    margin: 0;
    line-height: 39px;
    position: fixed;
    text-align: center;
  }
}
</style>
